import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-note-modal',
  templateUrl: './workflow-note-modal.component.html',
  styleUrls: ['./workflow-note-modal.component.css']
})
export class WorkflowNoteModalComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() workflowTitle: string = '';
  @Input() entityName: string = '';
  @Input() createdAT: string = '';
  @Input() currentNote: string | null = null;
  @Input() successMessage: string = '';
  @Output() saveNote = new EventEmitter<string>();
  @Output() closeModal = new EventEmitter<void>();

  noteContent: string = '';

  ngOnInit(): void {
    this.noteContent = this.currentNote || '';
  }
  onSave(): void {
    this.saveNote.emit(this.noteContent);
  }
  onClose(): void {
    this.closeModal.emit();
  }
}